import React from 'react';

import { dashboardPdfApis } from '@apis/next/pdfApis';
import { Button } from '@components/Button';
import { QueryContainer } from '@components/QueryContainer';
import { useSearch } from '@hooks/next/useSearch';
import { useBlobURL } from '@hooks/useBlobURL';
import { makeMuiStyles, useCommonStyles } from '@styles/index';
import { createStrings } from '@utils/local';
import { printBlob } from '@utils/printBlob';
import { Helmet } from 'react-helmet';
import { Document, Page } from 'react-pdf';
import { z } from 'zod';

const useStyles = makeMuiStyles((theme, common) => ({
  customsCommodityExportWrapper: {
    margin: '0 auto',
    width: 'min-content',
  },
  operationPanel: {
    ...common.flexCenter,
    ...common.middleText,
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    background: theme.palette.primary.contrastText,
    padding: '10px 45px',
    width: '100%',
    boxShadow: '0px -4px 4px rgba(0, 0, 0, 0.25);',
  },
  operationBox: {
    ...common.flexInline,
    ...common.middleText,
    background: theme.palette.primary.contrastText,
    padding: '10px 45px',
    maxWidth: 750,
    width: '100%',
  },
  info: {
    flex: 1,
    ...common.flexColumn,
  },
  operation: {
    ...common.flexCenter,
    columnGap: 30,
  },
}));

const strings = createStrings({
  ja: {
    commodities: '輸入商品一覧',
    exportPdf: 'PDF出力',
    print: '印刷',
  },
});

export const CustomsCommodityExport = () => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  const {
    search: { d2dNo },
  } = useSearch(
    z.object({
      d2dNo: z.string(),
    }),
  );

  const pdfQuery = dashboardPdfApis.useGet('/dashboard/pdf/CustomsCommodity/:d2d_no', {
    params: {
      d2d_no: d2dNo,
    },
  });

  const pdfUrl = useBlobURL(pdfQuery.data);

  const renderOperationPanel = () => {
    return (
      <div className={classes.operationPanel}>
        <div className={classes.operationBox}>
          <div className={classes.info} />
          <div className={classes.operation}>
            <Button
              color="primary"
              text={strings.exportPdf}
              type="button"
              shape="round"
              size="small"
              onClick={() => window.open(pdfUrl!)}
            />

            <Button
              color="primary"
              text={strings.print}
              type="button"
              shape="round"
              size="small"
              onClick={() => printBlob(pdfUrl!)}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={classes.customsCommodityExportWrapper}>
      <Helmet>
        <title>
          {strings.commodities} {d2dNo}
        </title>
      </Helmet>

      <QueryContainer queries={[pdfQuery]}>
        <Document file={pdfUrl} loading="">
          <Page pageNumber={1} width={900} />
        </Document>
      </QueryContainer>

      {renderOperationPanel()}
    </div>
  );
};
